import type { Config } from "./types";

/** Public, free infrastructure. Override per deployment with /config.json or settings. */
export const DEFAULT_CONFIG: Config = {
  iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:stun1.l.google.com:19302"] }],
  signaling: [
    {
      type: "nostr",
      // Checked with `pnpm --filter @codeshare/signaling probe-relays` (each must relay ephemeral
      // events end to end). All are used at once; any one being reachable is enough.
      relays: [
        "wss://relay.damus.io",
        "wss://nos.lol",
        "wss://relay.primal.net",
        "wss://nostr.mom",
        "wss://relay.snort.social",
      ],
    },
  ],
  iceTransportPolicy: "all",
  // n0's public relays (the iroh project's own defaults). Browsers use whichever answers
  // fastest. Override with your own relay (https://github.com/n0-computer/iroh) in /config.json.
  irohRelays: [
    "https://use1-1.relay.n0.iroh.link./",
    "https://usw1-1.relay.n0.iroh.link./",
    "https://euc1-1.relay.n0.iroh.link./",
    "https://aps1-1.relay.n0.iroh.link./",
  ],
};
